import ProductCategoryPage from "@/components/ProductCategoryPage";
import { productPages } from "@/data/productPages";
export default function Beauty() { return <ProductCategoryPage data={productPages.beauty} />; }
